import { Link } from "react-router-dom";
import { Camera, QrCode, Link as LinkIcon } from "lucide-react";

import { Button, LinkButton } from "@/components/ui/Button";
import { Card } from "@/components/ui/Card";
import { Logo } from "@/components/ui/Logo";
import { PublicLayout } from "@/components/layout/PublicLayout";

export function EntryPage() {
  return (
    <PublicLayout>
      <div className="w-full max-w-[420px] animate-fade-in">
        <Logo size="lg" showTagline />

        <Card padding="lg" className="mt-8 text-center">
          <div className="mx-auto grid h-32 w-32 place-items-center rounded-[20px] bg-[#e6f1fb] text-[#2563eb]">
            <QrCode className="h-16 w-16" strokeWidth={1.5} />
          </div>

          <h2 className="mt-6 text-[22px] font-bold tracking-tight text-[#1a1a1a]">
            Scan the QR code
          </h2>
          <p className="mt-2 text-[14px] text-[#6c757d]">
            Find the QR at the entrance or on the tables. One scan and you're in.
          </p>

          <Button
            type="button"
            fullWidth
            className="mt-6"
            leadingIcon={<Camera className="h-5 w-5" />}
            onClick={() => alert("Use your phone camera to scan the QR.")}
          >
            Open camera
          </Button>

          <div className="my-5 flex items-center gap-3">
            <div className="h-px flex-1 bg-[#e2e8f0]" />
            <span className="text-[12px] text-[#94a3b8]">or</span>
            <div className="h-px flex-1 bg-[#e2e8f0]" />
          </div>

          <LinkButton
            to="/e/demo"
            variant="secondary"
            fullWidth
            leadingIcon={<LinkIcon className="h-5 w-5" />}
          >
            Enter via link
          </LinkButton>
        </Card>

        <p className="mt-6 text-center text-[13px] text-[#94a3b8]">
          Are you an organizer?{" "}
          <Link to="/sign-in" className="font-semibold text-[#2563eb] hover:text-[#1d4ed8]">
            Sign in
          </Link>
        </p>
      </div>
    </PublicLayout>
  );
}
